import { render } from "./fluxo_lojas.vue?vue&type=template&id=51973f4f"
import script from "./fluxo_lojas.vue?vue&type=script&lang=js"
export * from "./fluxo_lojas.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__